/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'Etsimme kaikkialta, mutta sitä ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Emme löytäneet etsimääsi',
  'embedded.confluence.already-logged-in-paragraph': 'Oletko jo kirjautuneena sisään? Kokeile päivittää.',
  'embedded.confluence.footer.hover.text': 'Näytä Confluencessa',
  'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Kirjaudu sisään Confluenceen',
  'embedded.confluence.login-page.login-button': 'Kirjaudu sisään Confluenceen',
  'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
  'embedded.confluence.login-page.login-text': 'Sinun on oltava kirjautuneena sisään, jotta voit tarkastella tätä sivua',
  'embedded.confluence.login-page.refresh-page-banner': 'Tämän sivun tulisi päivittyä automaattisesti sisäänkirjautumisen jälkeen. Jos näin ei tapahdu, voit päivittää sivun napsauttamalla tätä.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Päivitä sivu',
  'embedded.confluence.need-to-log-in-paragraph': 'Sinun on oltava kirjautuneena sisään, jotta voit katsoa tätä sivua',
  'embedded.confluence.still-having-trouble-paragraph': 'Onko sinulla vielä ongelmia? Varmista, että kolmansien osapuolten evästeet ovat käytössä, tai {link}',
  'embedded.confluence.troubleshooting-link-text': 'katso tämä ongelmanratkaisuopas.',
  'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};